import { render, staticRenderFns } from "./col.vue?vue&type=template&id=197f17ee&scoped=true"
import script from "./col.vue?vue&type=script&lang=js"
export * from "./col.vue?vue&type=script&lang=js"
import style0 from "./col.vue?vue&type=style&index=0&id=197f17ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f17ee",
  null
  
)

export default component.exports